<template>
  <div
    :id="id"
    :class="className"
    :style="{height: height, width: width}"
  />
</template>

<script>
import resize from "../mixins/resize";
const echarts = require("echarts");

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "bar-chart",
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: "100%",
    },
    barData: {
      type: Array,
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    console.log(this.barData)
    this.initChart();
    if(this.barData[0].value==0&&this.barData[1].value==0){
      this.chart.setOption({
        yAxis: {
          max:10
        }
      })
    }else{
     
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  computed: {
      label: function() {
          return this.barData.map(item => item.name)
      }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption({
            tooltip: {
              trigger: 'item',
              position: 'top',
              formatter: function(obj){
            　　　　return obj.marker+obj.name+':  '+obj.value;
            　}
            },
            legend: {
              top: "6%",
              x:'right',      //可设定图例在左、右、居中
              itemHeight: 12,
              itemWidth: 12,
              itemGap: 10,
              textStyle:{
                  fontSize: "16rem",//字体大小
              },
              icon: 'rect',
            },
            xAxis: {
                type: 'category',
                data: this.label,                                  
                axisLabel: {
                    color: '#999999',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 400,
                        color: '#999999'
                    },
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    color: '#999999'
                }
            },
            yAxis: {
                type: 'value',
                name: '报警次数(次)',
                nameTextStyle: {
                    fontSize: 12,
                    color: '#999999',
                    fontWeight: 400,
                },
                max: function(value) {return value.max<10?10:value.max;},
                // min:function(value) {return value.min<6?6:value.min;},
                axisLine: {
                    show: true,
                    color: '#999999',
                },
                axisLabel: {
                    color: '#999999',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 400,
                        color: '#999999'
                    }, 
                    formatter: function (value, index) {
                        if(value >= 10000) {
                            return value/1000 + 'k';
                        }
                        return value;
                    }
                }
            },
            series:this.barData
      });
    },
    refresh() {
        if (!this.chart) {
            console.error('chart is null');
            return ;
        }
        if(this.barData[0].value==0&&this.barData[1].value==0){
          this.chart.setOption({
            yAxis: {
              max:10
            }
          })
        }else{
        
        }
        this.chart.setOption({
            xAxis: {
                data: this.label
            },
            
            legend: {},
            series: this.barData
        })
    }
  },
  watch: {
    barData: function (newData, oldData) {
        this.refresh()
    }
  }
};
</script>

<style lang="less" scoped>
body {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: chartreuse;
}
</style>